module.exports = __webpack_public_path__ + "static/img/bg7.15d698b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bg7.png
// module id = dlDM
// module chunks = 1